import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import {
  BankIcon,
  ClockIcon,
  StocksIcon,
  SearchIcon,
  CardIcon,
} from '@/components/TabIcons'
import { useTheme } from '@/hooks/useTheme'
import useOffsets from '@/hooks/useOffsets'
import { useGetWallet } from '@/domain'

interface TabItem {
  path: string
  IconComponent: React.ComponentType<{ color?: string; size?: number }>
  label: string
}

const tabs: TabItem[] = [
  {
    path: '/dashboard',
    IconComponent: BankIcon,
    label: 'Home',
  },
  {
    path: '/activity',
    IconComponent: ClockIcon,
    label: 'Activity',
  },
  {
    path: '/stocks',
    IconComponent: StocksIcon,
    label: 'Stocks',
  },
  {
    path: '/community',
    IconComponent: SearchIcon,
    label: 'Community',
  },
  {
    path: '/kem-card',
    IconComponent: CardIcon,
    label: 'Card',
  },
]

export const BottomNavigation: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()
  const offsets = useOffsets()

  const handleTabPress = (path: string) => {
    navigate(path)
  }
  const { data: walletData } = useGetWallet()
  const hasCards = walletData?.cards?.length && walletData?.cards?.length > 0

  const isTabActive = (tabPath: string) => {
    if (tabPath === '/stocks') {
      return location.pathname.startsWith('/stocks')
    }
    return location.pathname === tabPath
  }

  const isSendRequestPage = location.pathname === '/send-request'
  const isKemCardPage = location.pathname === '/kem-card'
  const isKemCardPageWithoutCard = isKemCardPage && !hasCards
  const isTransparentNav = isSendRequestPage || isKemCardPageWithoutCard

  return (
    <BaseView
      row
      justify="space-around"
      align="center"
      py={12}
      px={8}
      style={{
        backgroundColor: isTransparentNav
          ? 'transparent'
          : theme.colors.background.screen,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        minHeight: '80px',
        paddingBottom: offsets.bottom || 12,
      }}
    >
      {tabs.map((tab) => {
        const isActive = isTabActive(tab.path)
        const iconColor = isActive
          ? theme.colors.icon.activeIconTabNav
          : 'rgba(255, 255, 255, 0.6)'

        return (
          <BaseView
            key={tab.path}
            align="center"
            gap={4}
            style={{
              cursor: 'pointer',
              opacity: isActive ? 1 : 0.6,
              transition: 'opacity 0.2s ease',
            }}
            onClick={() => handleTabPress(tab.path)}
          >
            {/* Icon */}
            <BaseView
              align="center"
              justify="center"
              style={{
                width: '28px',
                height: '28px',
              }}
            >
              <tab.IconComponent color={iconColor} size={24} />
            </BaseView>

            {/* Label */}
            <BaseText
              fontSize={12}
              fontFamily="medium"
              color={
                isActive ? 'icon.activeIconTabNav' : 'icon.disabledIconTabNav'
              }
              textAlign="center"
              style={{
                color: isActive
                  ? theme.colors.icon.activeIconTabNav
                  : 'rgba(255, 255, 255, 0.6)',
              }}
            >
              {tab.label}
            </BaseText>
          </BaseView>
        )
      })}
    </BaseView>
  )
}
